export default __webpack_public_path__ + "static/media/hamburger.ef1142c1.svg";